import React from 'react';
import { Alert } from 'antd';
import { useAuth } from '../AuthContext';
import KipMark from './KipMark';
import GoogleSignInButton from './GoogleSignInButton';
import WatercolorLoader from './WatercolorLoader';
import './LoginModal.css';

const KIP_SIZE = 72;

const LoginModal = () => {
  const { loading, error, signInWithGoogle } = useAuth();

  return (
    <div className="login-screen">
      <div className="login-screen__card" role="dialog" aria-modal="true" aria-labelledby="login-brand">
        <div className="login-screen__brand" id="login-brand">
          <span className="login-screen__kip" style={{ width: KIP_SIZE, height: KIP_SIZE }}>
            <KipMark size={KIP_SIZE} alt="" />
          </span>
          <div className="login-screen__word-block">
            <span className="login-screen__wordmark-stem" aria-hidden="true">
              Artificiall
            </span>
            <span className="login-screen__wordmark-y" aria-hidden="true">
              y
            </span>
            <span className="login-screen__tagline">Intelligent Illustration Studio</span>
            <span className="login-screen__sr-only">Artificiallly</span>
          </div>
        </div>

        {loading ? (
          <div className="login-screen__loading" aria-busy="true">
            <WatercolorLoader size="large" label="Signing in" />
          </div>
        ) : (
          <>
            {error ? (
              <Alert
                type="error"
                title={error}
                showIcon
                closable
                className="login-screen__error"
              />
            ) : null}

            <GoogleSignInButton onClick={signInWithGoogle} />
          </>
        )}
      </div>
    </div>
  );
};

export default LoginModal;
